export default __webpack_public_path__ + "static/media/iphone8_angle.67d22d35.png";